import React, { useState } from "react";

import {
  Box,
  Flex,
  IconFlybuys,
  Link,
  LinkButton,
  NotificationBadge,
  Text,
} from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import {
  HeaderTile,
  HeaderTileRenderProps,
} from "../../../components/HeaderTile";
import { SpanWithAfterDownArrow } from "../../../components/SpanWithAfterDownArrow";
import { sessionStorage } from "../../../utilities/index";
import flybuysTheme from "../../flybuysTheme";
import { HeaderTileContainer } from "../HeaderTileContainer";

const LinkFlybuysButton = styled(LinkButton)`
  transform: translateY(-50%);
`;

const SESSION_STORAGE_KEY = "flyBuysTileHover";

export const FlybuysTile: React.FC = () => {
  const flyBuysTileHoverSessionStorage =
    sessionStorage?.getItem(SESSION_STORAGE_KEY) != "true";
  const [showNotificationBadge, setShowNotificationBadge] = useState(true);

  const renderFlybuysContent = () => {
    return (
      <Flex
        width="400px"
        flexDirection="column"
        color="typography.text"
        boxShadow="0 2px 4px 0 rgba(0,0,0,0.50)"
        bg="white"
      >
        <Flex
          position="relative"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p="1em 1em 2.2em"
          color="white"
          overflow="hidden"
          backgroundColor="secondary"
        >
          <Text textStyle="h3" m="0" textAlign="center">
            Deals, meet points
          </Text>
          <Text m="0" textAlign="center">
            Collect 1 point per $2 spent with Catch<sup>*</sup>
          </Text>
        </Flex>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <LinkFlybuysButton
            block={false}
            sizeVariant="sm"
            variant="primary"
            minWidth="170px"
            mb="-2em"
            textTransform="none"
            href="/rewards/flybuys/link"
            data-tracking="header-app-flybuys-link-flybuys"
          >
            LINK flybuys
          </LinkFlybuysButton>
          <Flex
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
            width="100%"
            p="15px 15px 5px 15px"
          >
            <Link
              href="/flybuys-catch"
              data-tracking="header-app-flybuys-learn-more"
            >
              Learn More
            </Link>
          </Flex>
          <Text textStyle="small" p="5px 15px 15px 15px">
            <sup>*</sup> Terms, conditions and exclusions apply
          </Text>
        </Flex>
      </Flex>
    );
  };

  const renderIcon: HeaderTileRenderProps = ({ isOpen }) => {
    const iconStyleOnHover = {
      svg: {
        fill: flybuysTheme.bgColor,
      },
    };

    const iconStyle = {
      "&:hover": iconStyleOnHover,
      svg: isOpen ? iconStyleOnHover.svg : undefined,
    };

    return (
      <HeaderTileContainer
        hasRightBorder
        linkProps={{
          css: iconStyle,
          backgroundColor: isOpen ? "white" : undefined,
          color: isOpen ? "secondary" : "inherit",
          href: "/rewards/flybuys/link",
          "aria-label": "flybuys",
          className: "js-dnt",
          "data-tracking": "header-app-flybuys",
        }}
        flexProps={{
          px: "0.875rem",
        }}
      >
        <Flex flexDirection="column" alignItems="center">
          <Box position="relative" title="Flybuys">
            {flyBuysTileHoverSessionStorage && showNotificationBadge && (
              <NotificationBadge
                text={"1"}
                data-testid="flybuys-new"
                absRight="-18px"
              />
            )}
            <IconFlybuys width={"65px"} height={"34px"} title="Flybuys icon" />
          </Box>
          <SpanWithAfterDownArrow>$2 = 1 point</SpanWithAfterDownArrow>
        </Flex>
      </HeaderTileContainer>
    );
  };

  return (
    <HeaderTile
      popoverProps={{
        placement: "bottom",
      }}
      icon={renderIcon}
      onTileShow={(isOpen) => {
        if (isOpen) {
          sessionStorage?.setItem(SESSION_STORAGE_KEY, "true");
          setShowNotificationBadge(false);
        }
      }}
    >
      {renderFlybuysContent()}
    </HeaderTile>
  );
};

export default FlybuysTile;
